import * as React from "react";
import classNames from "classnames";
import styles from "./List.module.css";

type RefFunction = (element: HTMLUListElement) => any;

interface ListProps<T extends any> {
  id?: string;
  data?: T[];
  className?: string;
  grid?: "2" | "3" | "4" | "5";
  skeletonsCount?: number;
  skeleton?: React.ReactNode;
  noContent?: React.ReactElement<any>;
  loading?: boolean | React.ReactElement<any>;
  innerRef?: React.MutableRefObject<HTMLUListElement> | RefFunction;
  mapKey(item: T, index: number): number | string;
  renderItem(item: T, index: number): React.ReactNode;
}

const List = <T extends any>({
  id,
  grid,
  mapKey,
  skeleton,
  noContent,
  renderItem,
  className,
  data = [],
  loading = false,
  skeletonsCount = 1,
  innerRef,
}: ListProps<T>): React.ReactElement<any> => {
  if (loading && typeof loading !== "boolean") {
    return loading;
  }

  if (!loading && noContent && data.length === 0) {
    return noContent;
  }

  return (
    <ul
      id={id}
      className={classNames(styles.wrapper, className, {
        [styles[`grid_${grid}`]]: grid,
      })}
      ref={innerRef}
    >
      {loading
        ? new Array(skeletonsCount)
            .fill(skeleton)
            .map((item) => <li key={Math.random()}>{item}</li>)
        : data.map((item, index) => (
            <li key={mapKey(item, index)}>{renderItem(item, index)}</li>
          ))}
    </ul>
  );
};

export default List;
